export default '#,##0.###';